import { BREAKPOINTS } from '@/constants/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';

/**
 * 섹션으로 스크롤 이동하고 searchParam에 tab 값을 추가합니다
 */
export const useScrollToSection = () => {
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);

  const defaultOffset = isDesktopViewport ? 70 : 48;

  const scrollToSectionWithTab = (
    tab: string,
    options?: {
      behavior?: ScrollBehavior;
      offset?: number;
    },
  ) => {
    const element = document.getElementById(tab);
    if (!element) return;

    const rect = element.getBoundingClientRect();
    const top =
      rect.top + window.scrollY - defaultOffset - (options?.offset ?? 0);

    window.scrollTo({
      top,
      behavior: options?.behavior ?? 'smooth',
    });

    const params = new URLSearchParams(window.location.search);
    params.set('tab', tab);
    const newUrl = `${window.location.pathname}?${params.toString()}`;

    window.history.replaceState(
      { ...window.history.state, as: newUrl, url: newUrl },
      '',
      newUrl,
    );
  };

  return { scrollToSectionWithTab };
};
